import { UPDATE_ALBUM } from '../actionTypes'

export const updateAlbum = (album_id: string, data: object) => ({
  type: UPDATE_ALBUM.name,
  api: {
    url: 'albums/update',
    data: { ...data, album_id },
  },
})
